"use client";

import { useEffect } from "react";
import Lenis from "lenis";

let lenis;

export const getLenis = () => lenis;

export const STSmoothScroll = () => {
  useEffect(() => {
    lenis = new Lenis({
      duration: 1.8,
      lerp: 0.08,
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };

    rafId = requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
      cancelAnimationFrame(rafId);
    };
  }, []);

  return null;
};
